/**
 * Variant Presets Configuration
 * Defines common variant keys and their corresponding values for different business types
 */

export const VARIANT_PRESETS = {
  // Fashion & Apparel
  FASHION: {
    label: 'Fashion & Apparel',
    keys: [
      { value: 'Color', label: 'Color' },
      { value: 'Size', label: 'Size' },
      { value: 'Style', label: 'Style' },
      { value: 'Material', label: 'Material' },
      { value: 'Size-Color', label: 'Size - Color' },
    ],
    values: {
      Color: [
        { value: 'Red', label: 'Red' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Green', label: 'Green' },
        { value: 'Black', label: 'Black' },
        { value: 'White', label: 'White' },
        { value: 'Yellow', label: 'Yellow' },
        { value: 'Orange', label: 'Orange' },
        { value: 'Pink', label: 'Pink' },
        { value: 'Purple', label: 'Purple' },
        { value: 'Brown', label: 'Brown' },
        { value: 'Gray', label: 'Gray' },
      ],
      Size: [
        { value: 'XS', label: 'Extra Small (XS)' },
        { value: 'S', label: 'Small (S)' },
        { value: 'M', label: 'Medium (M)' },
        { value: 'L', label: 'Large (L)' },
        { value: 'XL', label: 'Extra Large (XL)' },
        { value: '2XL', label: '2XL' },
        { value: '3XL', label: '3XL' },
      ],
      Style: [
        { value: 'Casual', label: 'Casual' },
        { value: 'Formal', label: 'Formal' },
        { value: 'Sports', label: 'Sports' },
        { value: 'Vintage', label: 'Vintage' },
      ],
      Material: [
        { value: 'Cotton', label: 'Cotton' },
        { value: 'Polyester', label: 'Polyester' },
        { value: 'Silk', label: 'Silk' },
        { value: 'Wool', label: 'Wool' },
        { value: 'Linen', label: 'Linen' },
      ],
      'Size-Color': [
        { value: 'XS-Red', label: 'XS - Red' },
        { value: 'XS-Blue', label: 'XS - Blue' },
        { value: 'S-Red', label: 'S - Red' },
        { value: 'S-Blue', label: 'S - Blue' },
        { value: 'M-Red', label: 'M - Red' },
        { value: 'M-Blue', label: 'M - Blue' },
        { value: 'L-Red', label: 'L - Red' },
        { value: 'L-Blue', label: 'L - Blue' },
        { value: 'XL-Red', label: 'XL - Red' },
        { value: 'XL-Blue', label: 'XL - Blue' },
      ],
    },
  },

  // Footwear
  FOOTWEAR: {
    label: 'Footwear',
    keys: [
      { value: 'Color', label: 'Color' },
      { value: 'Size', label: 'Size (EU)' },
      { value: 'Style', label: 'Style' },
    ],
    values: {
      Color: [
        { value: 'Red', label: 'Red' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Black', label: 'Black' },
        { value: 'White', label: 'White' },
        { value: 'Brown', label: 'Brown' },
        { value: 'Gray', label: 'Gray' },
      ],
      Size: [
        { value: '35', label: '35' },
        { value: '36', label: '36' },
        { value: '37', label: '37' },
        { value: '38', label: '38' },
        { value: '39', label: '39' },
        { value: '40', label: '40' },
        { value: '41', label: '41' },
        { value: '42', label: '42' },
        { value: '43', label: '43' },
        { value: '44', label: '44' },
        { value: '45', label: '45' },
      ],
      Style: [
        { value: 'Casual', label: 'Casual' },
        { value: 'Formal', label: 'Formal' },
        { value: 'Sports', label: 'Sports' },
        { value: 'Sneaker', label: 'Sneaker' },
      ],
    },
  },

  // Electronics
  ELECTRONICS: {
    label: 'Electronics',
    keys: [
      { value: 'Color', label: 'Color' },
      { value: 'Storage', label: 'Storage' },
      { value: 'Model', label: 'Model' },
      { value: 'Variant', label: 'Variant' },
    ],
    values: {
      Color: [
        { value: 'Black', label: 'Black' },
        { value: 'White', label: 'White' },
        { value: 'Silver', label: 'Silver' },
        { value: 'Gold', label: 'Gold' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Red', label: 'Red' },
      ],
      Storage: [
        { value: '64GB', label: '64GB' },
        { value: '128GB', label: '128GB' },
        { value: '256GB', label: '256GB' },
        { value: '512GB', label: '512GB' },
        { value: '1TB', label: '1TB' },
      ],
      Model: [
        { value: 'Standard', label: 'Standard' },
        { value: 'Pro', label: 'Pro' },
        { value: 'Ultra', label: 'Ultra' },
      ],
      Variant: [
        { value: 'WiFi', label: 'WiFi' },
        { value: 'WiFi+Cellular', label: 'WiFi + Cellular' },
      ],
    },
  },

  // Food & Beverage
  FOOD: {
    label: 'Food & Beverage',
    keys: [
      { value: 'Flavor', label: 'Flavor' },
      { value: 'Size', label: 'Size' },
      { value: 'Pack', label: 'Pack Size' },
      { value: 'Type', label: 'Type' },
      { value: 'Spice Level', label: 'Spice Level' },
    ],
    values: {
      Flavor: [
        { value: 'Original', label: 'Original' },
        { value: 'Strawberry', label: 'Strawberry' },
        { value: 'Vanilla', label: 'Vanilla' },
        { value: 'Chocolate', label: 'Chocolate' },
        { value: 'Mint', label: 'Mint' },
        { value: 'Spicy', label: 'Spicy' },
        { value: 'Sweet', label: 'Sweet' },
        { value: 'Savory', label: 'Savory' },
      ],
      Size: [
        { value: 'Small', label: 'Small' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Large', label: 'Large' },
        { value: 'XL', label: 'Extra Large' },
      ],
      'Pack Size': [
        { value: '500ml', label: '500ml' },
        { value: '1L', label: '1 Liter' },
        { value: '2L', label: '2 Liters' },
        { value: 'Bulk', label: 'Bulk' },
      ],
      Type: [
        { value: 'Hot', label: 'Hot' },
        { value: 'Cold', label: 'Cold' },
        { value: 'Frozen', label: 'Frozen' },
      ],
      'Spice Level': [
        { value: 'Mild', label: 'Mild' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Hot', label: 'Hot' },
        { value: 'Extra Hot', label: 'Extra Hot' },
      ],
    },
  },

  // Beauty & Salon
  BEAUTY: {
    label: 'Beauty & Salon',
    keys: [
      { value: 'Shade', label: 'Shade' },
      { value: 'Volume', label: 'Volume/Size' },
      { value: 'Type', label: 'Type' },
      { value: 'Finish', label: 'Finish' },
      { value: 'Fragrance', label: 'Fragrance' },
    ],
    values: {
      Shade: [
        { value: 'Light', label: 'Light' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Dark', label: 'Dark' },
        { value: 'Fair', label: 'Fair' },
        { value: 'Deep', label: 'Deep' },
      ],
      'Volume/Size': [
        { value: '50ml', label: '50ml' },
        { value: '100ml', label: '100ml' },
        { value: '200ml', label: '200ml' },
        { value: '500ml', label: '500ml' },
      ],
      Type: [
        { value: 'Dry', label: 'Dry' },
        { value: 'Oily', label: 'Oily' },
        { value: 'Combination', label: 'Combination' },
        { value: 'Sensitive', label: 'Sensitive' },
      ],
      Finish: [
        { value: 'Matte', label: 'Matte' },
        { value: 'Glossy', label: 'Glossy' },
        { value: 'Satin', label: 'Satin' },
        { value: 'Shimmer', label: 'Shimmer' },
      ],
      Fragrance: [
        { value: 'Floral', label: 'Floral' },
        { value: 'Citrus', label: 'Citrus' },
        { value: 'Herbal', label: 'Herbal' },
        { value: 'Unscented', label: 'Unscented' },
      ],
    },
  },

  // Gym & Fitness
  FITNESS: {
    label: 'Gym & Fitness',
    keys: [
      { value: 'Size', label: 'Size' },
      { value: 'Color', label: 'Color' },
      { value: 'Type', label: 'Type' },
      { value: 'Weight', label: 'Weight' },
      { value: 'Material', label: 'Material' },
    ],
    values: {
      Size: [
        { value: 'XS', label: 'Extra Small' },
        { value: 'S', label: 'Small' },
        { value: 'M', label: 'Medium' },
        { value: 'L', label: 'Large' },
        { value: 'XL', label: 'Extra Large' },
      ],
      Color: [
        { value: 'Black', label: 'Black' },
        { value: 'Gray', label: 'Gray' },
        { value: 'Red', label: 'Red' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Green', label: 'Green' },
      ],
      Type: [
        { value: 'Dumbbell', label: 'Dumbbell' },
        { value: 'Barbell', label: 'Barbell' },
        { value: 'Kettlebell', label: 'Kettlebell' },
        { value: 'Resistance Band', label: 'Resistance Band' },
      ],
      Weight: [
        { value: '2kg', label: '2kg' },
        { value: '5kg', label: '5kg' },
        { value: '10kg', label: '10kg' },
        { value: '20kg', label: '20kg' },
      ],
      Material: [
        { value: 'Rubber', label: 'Rubber' },
        { value: 'Metal', label: 'Metal' },
        { value: 'Foam', label: 'Foam' },
      ],
    },
  },

  // Travel & Hotel
  TRAVEL: {
    label: 'Travel & Hotel',
    keys: [
      { value: 'Room Type', label: 'Room Type' },
      { value: 'Occupancy', label: 'Occupancy' },
      { value: 'View', label: 'View' },
      { value: 'Board Basis', label: 'Board Basis' },
      { value: 'Duration', label: 'Duration' },
    ],
    values: {
      'Room Type': [
        { value: 'Single', label: 'Single Room' },
        { value: 'Double', label: 'Double Room' },
        { value: 'Twin', label: 'Twin Room' },
        { value: 'Suite', label: 'Suite' },
      ],
      Occupancy: [
        { value: '1', label: '1 Person' },
        { value: '2', label: '2 People' },
        { value: '3', label: '3 People' },
        { value: '4', label: '4+ People' },
      ],
      View: [
        { value: 'City View', label: 'City View' },
        { value: 'Sea View', label: 'Sea View' },
        { value: 'Mountain View', label: 'Mountain View' },
        { value: 'Standard', label: 'Standard' },
      ],
      'Board Basis': [
        { value: 'Room Only', label: 'Room Only' },
        { value: 'Breakfast', label: 'Breakfast Included' },
        { value: 'Half Board', label: 'Half Board' },
        { value: 'Full Board', label: 'Full Board' },
      ],
      Duration: [
        { value: '1 Night', label: '1 Night' },
        { value: '3 Nights', label: '3 Nights' },
        { value: '1 Week', label: '1 Week' },
        { value: 'Monthly', label: 'Monthly' },
      ],
    },
  },

  // Home & Gifts
  HOME: {
    label: 'Home & Gifts',
    keys: [
      { value: 'Color', label: 'Color' },
      { value: 'Size', label: 'Size' },
      { value: 'Material', label: 'Material' },
      { value: 'Style', label: 'Style' },
      { value: 'Design', label: 'Design' },
    ],
    values: {
      Color: [
        { value: 'Red', label: 'Red' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Green', label: 'Green' },
        { value: 'White', label: 'White' },
        { value: 'Black', label: 'Black' },
      ],
      Size: [
        { value: 'Small', label: 'Small' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Large', label: 'Large' },
        { value: 'XL', label: 'Extra Large' },
      ],
      Material: [
        { value: 'Wood', label: 'Wood' },
        { value: 'Metal', label: 'Metal' },
        { value: 'Glass', label: 'Glass' },
        { value: 'Ceramic', label: 'Ceramic' },
      ],
      Style: [
        { value: 'Modern', label: 'Modern' },
        { value: 'Traditional', label: 'Traditional' },
        { value: 'Vintage', label: 'Vintage' },
        { value: 'Minimalist', label: 'Minimalist' },
      ],
      Design: [
        { value: 'Floral', label: 'Floral' },
        { value: 'Geometric', label: 'Geometric' },
        { value: 'Abstract', label: 'Abstract' },
        { value: 'Plain', label: 'Plain' },
      ],
    },
  },

  // Laundry & Cleaning
  CLEANING: {
    label: 'Laundry & Cleaning',
    keys: [
      { value: 'Service Type', label: 'Service Type' },
      { value: 'Quantity', label: 'Quantity' },
      { value: 'Finish', label: 'Finish' },
      { value: 'Fabric Type', label: 'Fabric Type' },
      { value: 'Rush', label: 'Rush Service' },
    ],
    values: {
      'Service Type': [
        { value: 'Washing', label: 'Washing Only' },
        { value: 'Dry Cleaning', label: 'Dry Cleaning' },
        { value: 'Ironing', label: 'Ironing' },
        { value: 'Full Service', label: 'Full Service' },
      ],
      Quantity: [
        { value: '1kg', label: '1kg' },
        { value: '5kg', label: '5kg' },
        { value: '10kg', label: '10kg' },
        { value: 'Bulk', label: 'Bulk' },
      ],
      Finish: [
        { value: 'Basic', label: 'Basic' },
        { value: 'Premium', label: 'Premium' },
        { value: 'Express', label: 'Express' },
      ],
      'Fabric Type': [
        { value: 'Cotton', label: 'Cotton' },
        { value: 'Silk', label: 'Silk' },
        { value: 'Wool', label: 'Wool' },
        { value: 'Mixed', label: 'Mixed' },
      ],
      'Rush Service': [
        { value: 'Standard', label: 'Standard (3-5 days)' },
        { value: 'Express', label: 'Express (1-2 days)' },
        { value: 'Same Day', label: 'Same Day' },
      ],
    },
  },

  // General/Other
  GENERAL: {
    label: 'General',
    keys: [
      { value: 'Color', label: 'Color' },
      { value: 'Size', label: 'Size' },
      { value: 'Type', label: 'Type' },
      { value: 'Model', label: 'Model' },
      { value: 'Version', label: 'Version' },
    ],
    values: {
      Color: [
        { value: 'Red', label: 'Red' },
        { value: 'Blue', label: 'Blue' },
        { value: 'Green', label: 'Green' },
        { value: 'Black', label: 'Black' },
        { value: 'White', label: 'White' },
      ],
      Size: [
        { value: 'Small', label: 'Small' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Large', label: 'Large' },
        { value: 'XL', label: 'Extra Large' },
      ],
      Type: [
        { value: 'Type A', label: 'Type A' },
        { value: 'Type B', label: 'Type B' },
        { value: 'Type C', label: 'Type C' },
      ],
      Model: [
        { value: 'Model 1', label: 'Model 1' },
        { value: 'Model 2', label: 'Model 2' },
        { value: 'Model 3', label: 'Model 3' },
      ],
      Version: [
        { value: 'v1', label: 'Version 1' },
        { value: 'v2', label: 'Version 2' },
        { value: 'v3', label: 'Version 3' },
      ],
    },
  },
};

/**
 * Get variant presets for a business type
 * @param {string} businessType - The business type key
 * @returns {object} The variant preset configuration
 */
export const getVariantPresetByBusinessType = (businessType) => {
  return VARIANT_PRESETS[businessType] || VARIANT_PRESETS.GENERAL;
};

/**
 * Get all available variant keys for a business type
 * @param {string} businessType - The business type key
 * @returns {array} Array of variant key options
 */
export const getVariantKeysForBusinessType = (businessType) => {
  const preset = getVariantPresetByBusinessType(businessType);
  return preset.keys;
};

/**
 * Get variant values for a specific key in a business type
 * @param {string} businessType - The business type key
 * @param {string} variantKey - The variant key
 * @returns {array} Array of variant value options
 */
export const getVariantValuesForKey = (businessType, variantKey) => {
  const preset = getVariantPresetByBusinessType(businessType);
  const values = preset.values[variantKey] || [];
  return values;
};

/**
 * Custom option for user input
 */
export const CUSTOM_OPTION = {
  value: 'CUSTOM',
  label: 'Custom',
};
/**
 * Mapping of business type strings (from signup/account) to variant preset keys
 * This maps the display names to the preset keys for variant selection
 */
export const BUSINESS_TYPE_TO_PRESET = {
  // Food & Drinks category
  'Food and Drinks': 'FOOD',
  'Food & Drinks': 'FOOD',
  
  // Fashion & Accessories
  'Fashion and Accessories': 'FASHION',
  'Fashion & Accessories': 'FASHION',
  
  // Salon and Beauty
  'Salon and Beauty': 'BEAUTY',
  'Beauty and Spa': 'BEAUTY',
  
  // Gym and Fitness
  'Gym and Fitness': 'FITNESS',
  'Fitness': 'FITNESS',
  
  // Travel and Hotel
  'Travel and Hotel': 'TRAVEL',
  'Travel & Hotel': 'TRAVEL',
  'Trips': 'TRAVEL',
  'Staycation': 'TRAVEL',
  
  // Home and Gifts
  'Home and Gifts': 'HOME',
  'Home & Gifts': 'HOME',
  
  // Laundry / Washing and Cleaning
  'Washing and Cleaning': 'CLEANING',
  'Laundry': 'CLEANING',
  
  // Gadgets and Electronics
  'Gadgets and Electronics': 'ELECTRONICS',
  'Gadgets & Electronics': 'ELECTRONICS',
  
  // Photography
  'Photography': 'GENERAL',
  
  // Groceries
  'Groceries': 'FOOD',
  
  // Bookstore
  'Bookstore': 'GENERAL',
  
  // Healthcare
  'Healthcare': 'GENERAL',
  
  // Others
  'Others': 'GENERAL',
  'Other': 'GENERAL',
};

/**
 * Get variant preset by business type string
 * @param {string} businessTypeString - The business type name (from signup/account)
 * @returns {object} The variant preset configuration
 */
export const getVariantPresetByBusinessTypeString = (businessTypeString) => {
  if (!businessTypeString) return VARIANT_PRESETS.GENERAL;
  
  const presetKey = BUSINESS_TYPE_TO_PRESET[businessTypeString];
  return VARIANT_PRESETS[presetKey] || VARIANT_PRESETS.GENERAL;
};